import {
  BodyText,
  HeadingText,
  Link,
  ThemeProvider,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React, { memo } from 'react'
import { privacyRightsConfig } from '../../config/privacy-hub'

const PrivacyRights = memo(() => (
  <ThemeProvider theme="v2">
    <div id="privacyHubRights">
      {privacyRightsConfig.map(({ key, title, body, link, href, name }) => (
        <div key={key} className="privacy-hub-data-rights-section">
          <HeadingText
            size="sm"
            className="privacy-hub-title-text"
            id={`${key}Title`}
          >
            <Message id={title} />
          </HeadingText>
          <div className="privacy-hub-data-rights-description">
            {body.map(({ id = '', bodyHref = null, bodyName }, index) => {
              return bodyHref ? (
                <BodyText
                  key={id}
                  className="privacy-hub-body-text privacy-hub-data-rights-body-text"
                  id={`${key}Body${index}`}
                >
                  <Message
                    id={id}
                    link={(innerMessage) => (
                      <Link
                        href={bodyHref}
                        className="privacy-hub-hyper-link"
                        name={bodyName}
                        id={`${key}BodyLink${index}`}
                      >
                        {innerMessage}
                      </Link>
                    )}
                  />
                </BodyText>
              ) : (
                <BodyText
                  key={id}
                  className="privacy-hub-body-text privacy-hub-data-rights-body-text"
                  id={`${key}Body${index}`}
                >
                  <Message id={id} />
                </BodyText>
              )
            })}
          </div>
          {link && href && (
            <BodyText className="privacy-hub-body-text" id={`${key}LinkDesc`}>
              <Message
                id={link}
                link={(innerMessage) => (
                  <Link
                    className="privacy-hub-link privacy-hub-hyper-link"
                    href={href}
                    name={name}
                    id={`${key}Link`}
                  >
                    {innerMessage}
                    <span className="link-arrow-icon" />
                  </Link>
                )}
              />
            </BodyText>
          )}
        </div>
      ))}
    </div>
  </ThemeProvider>
))

PrivacyRights.displayName = 'PrivacyRights'

export default PrivacyRights
